import { Routes } from '@angular/router';

import { VANILLA_LAZY_ROUTES } from '@frontend/loaders/routes';
import { ClientConfigProductName, routeData } from '@frontend/vanilla/core';

import { BingoWidgetComponent } from './BingoWidget/bingo-widget.component';
import { BINGO_ROUTES } from './bingo.routes';
import { PrebuyRedirectComponent } from './force-redirect/pre-buy-redirect.component';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './main/main.component';
import { ConfigResolver } from './resolver/config-resolver.component';
import { RoomsListComponent } from './rooms/rooms-list/rooms-list.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: MainComponent,
        resolve: {
            config: ConfigResolver,
        },
        children: [
            {
                path: '',
                component: HomeComponent,
                data: { Home: 'true' },
                resolve: {
                    config: ConfigResolver,
                },
            },
            {
                path: 'games-info/:room-name',
                component: RoomsListComponent,
                resolve: {
                    config: ConfigResolver,
                },
            },

            {
                path: 'forcedprebuy',
                component: PrebuyRedirectComponent,
                resolve: {
                    config: ConfigResolver,
                },
            },
        ],
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: '{culture}',
        children: [
            ...VANILLA_LAZY_ROUTES,
            {
                path: 'p',
                loadChildren: () => import('@frontend/vanilla/features/public-page').then((m) => m.ROUTES),
                data: {
                    publicPageRoot: 'MobilePortal-v1.0/PublicPages/',
                    product: ClientConfigProductName.BINGO,
                },
            },
            {
                path: '',
                component: MainComponent,
                resolve: {
                    config: ConfigResolver,
                },
                children: [
                    {
                        path: '',
                        component: HomeComponent,
                        data: { Home: 'true' },
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: 'games-info/:room-name',
                        component: RoomsListComponent,
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                    {
                        path: 'forcedprebuy',
                        component: PrebuyRedirectComponent,
                        resolve: {
                            config: ConfigResolver,
                        },
                    },
                ],
                data: routeData({ allowAnonymous: true }),
            },
            {
                path: 'bingo',
                children: [...BINGO_ROUTES],
            },
            {
                path: 'bingowidget/cozybingo',
                component: BingoWidgetComponent,
                resolve: {
                    config: ConfigResolver,
                },
            },
        ],
    },
    {
        path: '**',
        loadChildren: () => import('@frontend/vanilla/features/not-found').then((m) => m.ROUTES),
    },
];
